import { assignmentTypes } from "../../../constants/constants";
import { getScreeningWindow } from "../../../services/screeningWindowService";
import { getUserData } from "../../../services/API";

export default function getActivityType(type, tags, date) {
    const activityWindow = getScreeningWindow(new Date(date));
    if (type === "assessment") {
      if (tags && tags.includes("BENCHMARK") && tags.includes(activityWindow)) return "Assessment";
      else return "Progress Monitor";
    }
    if (type === assignmentTypes.LETTER_NAMING_AND_SOUNDS) {
      return "Letter Names and Sounds"
    }
    return type[0].toUpperCase() + type.slice(1)
  }

export function isBenchmarkAssessment(activity) {
  if (!activity) return false;
  const activityWindow = getScreeningWindow(new Date(activity.createdAt));
  return activity?.type === "assessment" && activity?.story?.tags?.includes("BENCHMARK") && (getUserData().demoLockdown || activity?.story?.tags?.includes(activityWindow));
}